import UniversalButtonComponent from "./UniversalButtonComponent";

export default UniversalButtonComponent;